<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      Image
      <i class="fa fa-fw fa-question-circle" v-tooltip data-placement="right" title="Pull image from supplier"></i>
    </div>
    <div class="panel-body">
      <div class="form-horizontal">
        <div class="form-group">
          <label class="control-label col-lg-2">Image Name</label>
          <div class="col-lg-10">
            <input class="form-control" type="text" v-model="imageName" :disabled="loading" />
          </div>
        </div>
        <div class="form-group">
          <label class="control-label col-lg-2">Product ID</label>
          <div class="col-lg-3">
            <input class="form-control" type="text" v-model="productId" :disabled="loading" />
          </div>
        </div>
        <div class="form-group">
          <label class="control-label col-lg-2">Supplier</label>
          <div class="col-lg-3">
            <select class="form-control" v-model="supplierId" :disabled="loading">
              <option :value="null">Sellect Supplier</option>
              <option v-for="(opt, key) in supplierOptions" :key="key" :value="opt.value" v-html="opt.label"></option>
            </select>
          </div>
        </div>
        <div class="form-group">
          <div class="col-lg-offset-2 col-lg-10">
            <button type="button" class="btn btn-default" @click="applyPayload" :disabled="!formIsOk || loading"><i class="fa fa-fw fa-check"></i> Apply</button>
            &nbsp;
            <button type="button" class="btn btn-default" @click="clearForm" :disabled="!formIsOk || loading"><i class="fa fa-fw fa-times"></i> Clear</button>
          </div>
        </div>
      </div><!-- .form-horizontal -->
    </div><!-- .panel-body -->
  </div><!-- .panel -->
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import ApiResponseMixin from '@/plugin/mixin/api-response'
import Tooltip from '@/plugin/directive/tooltip'

export default {
  name: 'sync-by-product-form-component',
  data() {
    return {
      productId: null,
      supplierId: null,
      imageName: null
    }
  },
  computed: {
    ...mapState('dropship/seller/syncProduct', {
      supplierOptions: 'supplierOptions'
    }),
    ...mapGetters('dropship/seller/syncProduct', {
      isRequestingServer: 'isRequestingServer'
    }),
    formIsOk() {
      return this.productId && this.supplierId && this.imageName
    },
    loading() {
      return this.isRequestingServer
    }
  },
  methods: {
    viewPayload() {
      this.$store.dispatch(
        'dropship/seller/syncProduct/viewPayloadByProduct',
        {productId: this.productId, supplierId: this.supplierId, imageName: this.imageName}
      )
    },
    async applyPayload() {
      try {
        const response = await this.$store.dispatch(
          'dropship/seller/syncProduct/applyPayloadByImage',
          {productId: this.productId, supplierId: this.supplierId, imageName: this.imageName}
        )
        if (response) {
          this.$alertify.success('Product synchronized')
        } else {
          this.$alertify.error('Product NOT synchronized')
        }
      } catch (reason) {
        if (this.isResponseError(reason)) {
          this.raiseErrorMessage(reason)
        } else {
          this.$alertify.error('An error was raised while requesting to apply payload.  Message: ' + reason)
        }
      }
    },
    clearForm() {
      this.productId = null
      this.supplierId = null
      this.imageName = null
    }
  },
  directives: {
    tooltip: Tooltip
  },
  mixins: [
    ApiResponseMixin
  ]
}
</script>
